import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgPlus = (props) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	viewBox: "0 0 24 24",
	fill: "inherit",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "inherit",
		fillRule: "evenodd",
		d: "M11 18a1 1 0 1 0 2 0v-5h5a1 1 0 0 0 0-2h-5V6a1 1 0 1 0-2 0v5H6a1 1 0 1 0 0 2h5v5Z",
		clipRule: "evenodd"
	})
});
export default SvgPlus;
